<section class="emi-calc-wrap">
  <div class="wrap-lg">
    <div class="emi-calc-inner">
      <div class="nav-sec">
        <div class="back-nav" (click)="goTohome()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 6L9 12L15 18" stroke="#1A204B" stroke-width="1.75" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <span class="nav-name" >Back</span>
        </div>
      </div>
      <div class="page-head">
        <div class="head-left">
          <div class="page-title">EMI Calculator</div>
        </div>
      </div>
      <div class="box-wrap">
        <div class="emi-calc-content">
          <div class="gradient-line"></div>
          <div class="left">
            <div class="slide-item">
              <div class="label-sec">
                <div class="label-text">Loan Amount</div>
                <div>
                  <input type="text"  class="cus-input one"  [(ngModel)]="amount" maxlength="7" min="5000" minlength="4" (change)="calculateEMI"/>
                  <span *ngIf="!isAmountValid()" class="cus-input error">Amount not in range</span> 
                </div>
              </div>
              <div class="range-slide">
                <p-slider [(ngModel)]="amount" [step]="1000" [min]="5000" [max]="isSFLoan ? 1500000 : 500000" (onChange)="calculateEMI"></p-slider>
                <div class="slide-opt">
                  <span class="start">5,000</span>
                  <span class="end">{{isSFLoan ? '15,00,000' : '5,00,000'}}</span>
                </div>
              </div>
            </div>
            <div class="slide-item">
              <div class="label-sec">
                <div class="label-text">Annual Rate of Interest (in %)</div>
                <div>
                  <input type="text" class="cus-input two" [(ngModel)]="interest" maxlength="2" (change)="calculateEMI"/>
                  <span *ngIf="!isInterestValid()" class="cus-input error">Interest not in range</span> 
                </div>
              </div>
              <div class="range-slide">
                <p-slider [(ngModel)]="interest" [step]="0.01" [min]="isSFLoan ? 7.7 : 14" [max]="isSFLoan ? 8.9 : 16"  (onChange)="calculateEMI"></p-slider>
                <div class="slide-opt">
                  <span class="start">{{isSFLoan ? '7.7' : '14'}}</span>
                  <span class="end">{{isSFLoan ? '8.9' : '16'}}</span>
                </div>
              </div>
            </div>
            <div class="slide-item">
              <div class="label-sec">
                <div class="label-text">Tenure (in months)</div>
                <div>
                  <input type="text" class="cus-input three" [(ngModel)]="tenure" maxlength="2" minlength="1" (change)="calculateEMI"/>
                  <span *ngIf="!isTenureValid()" class="cus-input error">Tenure not in range</span> 
                </div>


              </div>
              <div class="range-slide">
                <p-slider [(ngModel)]="tenure" [step]="1" [min]="3" [max]="isSFLoan ? 12 : 36" (onChange)="calculateEMI"></p-slider>
                <div class="slide-opt">
                  <span class="start">3</span>
                  <span class="end">{{isSFLoan ? '12' : '36'}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="emi-box">
              <div class="emi-info">You wll be paying</div>
              <div class="emi-amt"><span class="lite">₹</span><span>{{calculateEMI}}</span></div>
              <div class="emi-info">per month for <span class="highlight">{{tenure}} months</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
